import { useQuery } from "@tanstack/react-query";
import { DepartmentAvailable } from "../../@types/attendance-local-department";
import { Paginated } from "../../@types/paginated";
import { apisiseci } from "../api";
import { DefaultFilter } from "../../@types/filter";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
    unidade?: string;
};

export function useDepartmentAvailableList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<Paginated<DepartmentAvailable>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ["department-available", "list", params],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<DepartmentAvailable>>(
                "/cms/setores_disponiveis/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
